'use client';

import {
  type TopAppBarProps,
  TopAppBar,
} from '@onyx/ui/components/colleague/top-app-bar';
import { usePathname, useRouter } from 'next/navigation';

import { trackBackNavigation } from '../../utils/help-hub-error-events';
import { useBackRoute } from './use-back-route';

type TopBarProps = Omit<TopAppBarProps, 'backButtonClick'> & {
  backRoute?: string;
};

export const TopBar = ({ backRoute, ...props }: TopBarProps) => {
  const router = useRouter();
  const pathname = usePathname();
  const defaultBackRoute = useBackRoute();
  const resolvedBackRoute = backRoute ?? defaultBackRoute;

  return (
    <TopAppBar
      {...props}
      backButtonClick={() => {
        /* istanbul ignore else */
        if (pathname) {
          trackBackNavigation({
            fromPath: pathname,
            toPath: resolvedBackRoute,
          });
        }

        router.push(resolvedBackRoute);
      }}
    >
      {props.children}
    </TopAppBar>
  );
};
